import { generateFeatureVoice } from '@/api/query/feature';
import {
	playAudioBase64,
	stopAllHowlerAudio,
} from '@/common/functions/howlerAudio';

/** @type {import('@/common/functions/howlerAudio').AudioHandle | null} */
let activeHandle = null;

export const stopPersonVoicePlayback = () => {
	activeHandle?.stop();
	activeHandle = null;
};

export const speakPersonVoice = async ({
	text,
	personId,
	language,
	onPhaseChange,
	onError,
}) => {
	const trimmedText = text?.trim();

	if (!trimmedText || !personId) {
		onPhaseChange?.('waiting');
		return;
	}

	stopPersonVoicePlayback();
	stopAllHowlerAudio();
	onPhaseChange?.('processing');

	try {
		const { data } = await generateFeatureVoice({
			person: personId,
			message: trimmedText,
			type: 'CHAT',
			language,
		});

		stopPersonVoicePlayback();
		onPhaseChange?.('speaking');

		const mimeType = data?.mimeType || 'audio/mpeg';
		activeHandle = playAudioBase64(data.audio, mimeType);

		await activeHandle.promise;
	} catch (e) {
		console.error(e);
		stopPersonVoicePlayback();
		onError?.();
	} finally {
		activeHandle = null;
		onPhaseChange?.('waiting');
	}
};
